/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicHolidayRecordModelSearchResultModel } from '../../models/public-holiday-record-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface PublicHolidaySearchPublicHolidayPost$Params {
      body?: SearchRequestModel
}

export function publicHolidaySearchPublicHolidayPost(http: HttpClient, rootUrl: string, params?: PublicHolidaySearchPublicHolidayPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<PublicHolidayRecordModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, publicHolidaySearchPublicHolidayPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<PublicHolidayRecordModelSearchResultModel>;
    })
  );
}

publicHolidaySearchPublicHolidayPost.PATH = '/PublicHoliday/SearchPublicHoliday';
